import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { AppState } from '../../types/store';
import {
  getFolderDeviationsStreamId,
  STREAM_PARAM_TYPE_FETCHING_PAUSED,
} from '../streams/folderDeviations';
import { getFolderById, getSubfolders } from './folders';

export const getGallectionSectionType = (state: AppState) =>
  state.gallectionSection.type;

export const getSelectedFolderId = (state: AppState) =>
  state.gallectionSection.selectedFolderId;

export const getSelectedFolder = (state: AppState) => {
  const selectedFolderId = getSelectedFolderId(state);
  const gallectionType = getGallectionSectionType(state);
  return (
    selectedFolderId && getFolderById(state, gallectionType, selectedFolderId)
  );
};

export const getSelectedSubfolderId = (state: AppState) =>
  state.gallectionSection.selectedSubfolderId;

export const getSelectedSubfolder = (state: AppState) => {
  const selectedSubfolderId = getSelectedSubfolderId(state);
  const gallectionType = getGallectionSectionType(state);
  return (
    selectedSubfolderId &&
    getFolderById(state, gallectionType, selectedSubfolderId)
  );
};

export const getCurrentlyViewedFolderId = (state: AppState) =>
  state.gallectionSection.currentlyViewedFolderId;

export const getCurrentlyViewedFolder = (state: AppState) => {
  const currentlyViewedFolderId = getCurrentlyViewedFolderId(state);
  const gallectionType = getGallectionSectionType(state);
  return (
    currentlyViewedFolderId &&
    getFolderById(state, gallectionType, currentlyViewedFolderId)
  );
};

export const getSortOrder = (state: AppState) =>
  state.gallectionSection.sortOrder;

export const getSearchInputValue = (state: AppState) =>
  state.gallectionSection.searchInputValue;

export const getSearchQuery = (state: AppState) =>
  state.gallectionSection.searchQuery;

export const getViewType = (state: AppState) =>
  state.gallectionSection.viewType;

export const getFullViewFolderIds = (state: AppState) =>
  state.gallectionSection.fullViewFolderIds;

export const getLastFullViewFolderStreamId = (state: AppState) => {
  const fullViewFolderIds = getFullViewFolderIds(state);
  const lastFullViewFolderId = fullViewFolderIds[fullViewFolderIds.length - 1];
  const gallectionType = getGallectionSectionType(state);
  const sortOrder = getSortOrder(state);
  const lastFullViewFolderStreamId = getFolderDeviationsStreamId(
    gallectionType,
    lastFullViewFolderId,
    sortOrder
  );
  return lastFullViewFolderStreamId;
};

export const getFolderTotalDeviationCount = (
  state: AppState,
  folderId: number
) => {
  const gallectionType = getGallectionSectionType(state);
  const folder = getFolderById(state, gallectionType, folderId);
  const subfolders = getSubfolders(state, folderId);
  const subfolderItemCount = subfolders
    ? subfolders.reduce((prevValue, subfolder) => prevValue + subfolder.size, 0)
    : 0;
  return folder.size + subfolderItemCount;
};

export const hasMoreDeviationsInLastFullViewFolder = (state: AppState) => {
  return streamSelectors.hasMore(state, getLastFullViewFolderStreamId(state));
};

export const isFetchingPausedInLastFullViewFolder = (state: AppState) => {
  return !!streamSelectors.getStreamParam(
    state,
    getLastFullViewFolderStreamId(state),
    STREAM_PARAM_TYPE_FETCHING_PAUSED
  );
};
